// extracted by mini-css-extract-plugin
export var autoExpand = "_1y-8";
export var container = "_1y-7";
export var containerWidth = "_1y-5";
export var disabled = "_1y-2";
export var error = "_1y-3";
export var fullWidth = "_1y-6";
export var inputWrapper = "_1y-0";
export var small = "_1y-1";
export var textarea = "_1y-4";